import { Reducer } from "redux";
import { ReadingModeOffAction, ReadingModeOnAction, READING_MODE_OFF, READING_MODE_ON } from "~/actions/readingMode";


type ActionTypes =
  | ReadingModeOnAction
  | ReadingModeOffAction


const initialState = false

export const readingModeReducer: Reducer<boolean, ActionTypes> = (
  previousState = initialState,
  action
) => {
  switch (action.type) {

    case READING_MODE_ON:
      return true
    case READING_MODE_OFF:
      return false
    default:
      return previousState;
  }
}

export const getReadingModeState = (state:any) => state.od.readingMode;

